'use strict'
import RoomPermutations from '../roomPermutations.js'
import sum from 'root-core/utils/array/sum.js'
import find from 'lowscore/find.js'

function roomsGroupedByType (roomAllocation, hotel, days) {
  const pricedAllocationByDay = priceRoomAllocation(hotel, roomAllocation, days)
  if (pricedAllocationByDay && pricedAllocationByDay.length > 0) {
    const rooms = RoomPermutations.groupRooms(roomAllocation)

    rooms.forEach(room => {
      room.adultPrice = pricedAllocationByDay.find(a => a.roomType == room.roomType).adultPrice
      room.childPrice = pricedAllocationByDay.find(a => a.roomType == room.roomType).childPrice
    })
    return {
      rooms,
      price: sum(pricedAllocationByDay.map(d => d.total)),
    }
  }
}

function countRooms (roomAllocation) {
  return sum(roomAllocation.rooms.map(r => r.count))
}

function compareByPriceAndCountAscending (a, b) {
  if (a.price < b.price) {
    return -1
  } else if (a.price > b.price) {
    return 1
  } else {
    var acount = countRooms(a)
    var bcount = countRooms(b)
    if (acount < bcount) {
      return -1
    } else if (acount > bcount) {
      return 1
    } else {
      return 0
    }
  }
}

export default function hotelRoomAllocations (hotel, days, party, features) {
  const childrenAllocationPolicy = features &&
    features.childrenAllocationPolicy &&
    features.childrenAllocationPolicy.teenagers &&
    features.childrenAllocationPolicy.teenagers.rooms
  const roomsByAllocation = RoomPermutations.buildRoomsByAllocation(hotel, childrenAllocationPolicy)
  const roomAllocations = RoomPermutations.enumerateRoomAllocations(
    party.adults,
    party.children,
    party.teenagers,
    roomsByAllocation
  ).map(ra => roomsGroupedByType(ra, hotel, days))

  var suggestedRoomAllocations = roomAllocations.slice()
  suggestedRoomAllocations.sort(compareByPriceAndCountAscending)


  return suggestedRoomAllocations
}

function findDay (hotel, day) {
  return find(hotel.days, d => d.date.toString() == day)
}

function priceRoomAllocation (hotel, roomAllocation, days) {
  const pricedRooms = []
  days.forEach(day => {
    var hotelDay = findDay(hotel, day)
    if (hotelDay) {
      roomAllocation.map((room, index) => {
        pricedRooms[index] = pricedRooms[index] || {
          roomType: room.roomType,
          total: 0,
          adultPrice: 0,
          childPrice: 0,
        }
        var roomDiscount = hotelDay.prices.adjustments.discounts.roomType[
          room.roomType
        ]
          ? hotelDay.prices.adjustments.discounts.roomType[room.roomType]
          : 0
        var childDiscount = hotelDay.prices.adjustments.discounts.child
          ? hotelDay.prices.adjustments.discounts.child.value
          : 0
        var supplement = hotelDay.prices.adjustments.supplements.roomType[
          room.roomType
        ]
          ? hotelDay.prices.adjustments.supplements.roomType[room.roomType]
          : 0
        const roomPrice =
          hotelDay.prices.baseRoomPrice - roomDiscount + supplement
        const childRoomPrice = childDiscount > roomDiscount
          ? hotelDay.prices.baseRoomPrice - childDiscount + supplement
          : roomPrice

        pricedRooms[index].total += roomPrice * room.adults + childRoomPrice * (room.children + room.teens)
        pricedRooms[index].adultPrice += roomPrice
        pricedRooms[index].childPrice += childRoomPrice
      })
      pricedRooms
    }
  })
  return pricedRooms
}
